import { SET_POLL_INTERVAL, SET_LAST_SYNC, QUEUE_STATE } from '../Actions/types';
import initialState from './initial-state';

export default function(state = initialState.rah, action) {
  switch (action.type) {

    case SET_POLL_INTERVAL:
    return { ...state, pollInterval: action.payload, syncing: action.syncing };

    case SET_LAST_SYNC:
        return { ...state, LastSync: { ...state.LastSync,  ...action.payload } };
    
    case QUEUE_STATE:
        return { ...state, queueState: action.payload };
        
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/rahReducer.js